import { useCallback, useState } from 'react';

import { CLOSED_COMPARE } from '../FormChangeHistory.constants';
import { getFormRowActions } from '../FormChangeHistory.utils';

/**
 * The drawer's "Compare with current": the row action that opens it on a row, with the rows loaded
 * at that moment to pick another version from, and the way back to the picked version's row.
 */
const useCompareWithCurrent = () => {
  const [compare, setCompare] = useState(CLOSED_COMPARE);

  const onCompare = useCallback(
    (row, { rows, openRow }) => setCompare({ auditId: row.auditId, isOpen: true, rows, openRow }),
    [],
  );

  const renderRowActions = useCallback(
    (row, context) => getFormRowActions(row, context, onCompare),
    [onCompare],
  );

  const onSelectVersion = useCallback(
    auditId => setCompare(previous => ({ ...previous, auditId })),
    [],
  );

  const onClose = useCallback(() => setCompare(previous => ({ ...previous, isOpen: false })), []);

  const onBack = useCallback(() => {
    compare.openRow?.(compare.auditId);
    onClose();
  }, [compare, onClose]);

  return { compare, renderRowActions, onSelectVersion, onClose, onBack };
};

export default useCompareWithCurrent;
